module.exports = __webpack_public_path__ + "media/images/vk-pay-21b6511a0a15f907fe1cffad58501dc9.svg";